import { LineWidgetSettingsComponent } from "./line-widget/line-widget-settings/line-widget-settings.component";
import { LineWidgetComponent } from "./line-widget/line-widget.component";
import { ListWidgetComponent } from "./list-widget/list-widget.component";
import { ListWidgetSettingsComponent } from "./list-widget/list-widget-settings/list-widget-settings.component";
import { DTCWidgetComponent } from "./dtc-widget/dtc-widget.component"
import { DTCWidgetSettingsComponent } from "./dtc-widget/dtc-widget-settings/dtc-widget-settings.component"

export const WidgetsComponents = [
    LineWidgetComponent,
    LineWidgetSettingsComponent,
    ListWidgetComponent,
    ListWidgetSettingsComponent,
    DTCWidgetComponent,
    DTCWidgetSettingsComponent
]